import React, { useEffect, useState } from "react";
import { RightOutlined, CloseOutlined } from "@ant-design/icons";
import { ReactComponent as Uploading } from "../../../../assets/Icons/upload.svg";
import { Button, Form, Input, message, Modal, Select, Upload } from "antd";
import { ReactComponent as Tick } from "../../../../assets/Icons/tick.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import UseApi from "../../../Reusable/CallApi/UseApi";
import { setOrgLogoUrl } from "../../../../Redux/systemSlice";

const StyledAcc = styled.div`
  .breadcrumb-style {
    display: flex;
    align-items: center;
    text-align: left;
    gap: 8px;
  }

  .rightoutlined-style {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #636980;
  }
  .account-style {
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #636980;
  }

  .editing-account-details {
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #1f243b;
  }

  .left-right-div {
    width: 48%;
  }

  .field-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .remove-logo-icon {
    cursor: pointer;
    color: #636980;
    font-size: 12px;
  }

  .form-item-style {
    text-align: left;
  }

  .organization-name {
    font-size: 14px;
    font-weight: 500;
    color: #636980;
  }

  .time-format {
    font-size: 14px;
    font-weight: 500;
    color: #636980;
  }

  .currency-text {
    font-size: 14px;
    font-weight: 500;
    color: #636980;
  }

  .logo-text {
    font-size: 14px;
    font-weight: 500;
    color: #636980;
  }

  .upload-button {
    width: 100%;
    height: 37px;
    padding: 6px 0;
    border-radius: 5px;
    background-color: #c2fae5;
    border: 1px solid #c2fae5;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .upload-div {
    display: flex;
    align-items: center;
  }

  .upload-span {
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    height: 34px;
    background-color: #f4f4f4;
    width: 100%;
    padding-left: 12px; /* 0.75rem = 12px */
    padding-right: 12px; /* 0.75rem = 12px */
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
  }

  .time-zone {
    font-size: 14px;
    font-weight: 500;
    color: #636980;
  }

  .button-style {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 80%;
    margin-left: 271px;
    background-color: white;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding: 20px;
    padding-top: 20px;
    box-shadow: 0px -1px 5px rgba(0, 0, 0, 0.2);
  }

  .cancel-button,
  .save-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    transition: none !important;
  }

  .cancel-button {
    border: 1px solid #1f243b;
    color: #1f243b;
    background-color: white;
  }

  .save-button {
    background-color: #c2fae5;
    color: black;
  }

  .cancel-button:hover,
  .cancel-button:active,
  .save-button:hover,
  .save-button:active {
    background-color: white !important;
    color: #1f243b !important;
    border-color: #1f243b !important;
  }

  .save-button:hover,
  .save-button:active {
    background-color: #c2fae5 !important;
    color: black !important;
    border: none !important;
  }

  .cancel-button:focus,
  .save-button:focus {
    outline: none !important;
  }

  .ant-input {
    height: 37px;
  }

  .ant-select {
    height: 37px;
  }

  .modal-div {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
  }

  .saved-style {
    font-size: 16px;
    font-weight: 400;
  }
`;

const { Option } = Select;
const AccountEditAdd = ({ setAccountView, accountData, accountId, accountLogoUrl, onSaved }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientId = useSelector((state) => state.authTracking.userInfo?.clientId);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [logoRemoved, setLogoRemoved] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  const { request } = UseApi();
  const { request: uploadUrlRequest } = UseApi();

  useEffect(() => {
    form.setFieldsValue({
      organizationName: accountData["Organization Name"] || "",
      timeFormat: accountData["Time Format"] || "",
      // Select option values now match the human-readable strings the
      // backend actually stores (e.g. "US Dollar", "IST") instead of a
      // fixed lowercase-code mapping that only ever matched one exact
      // value and silently overwrote everything else with a raw code.
      currency: accountData["Currency"] || "",
      timeZone: accountData["Time Zone"] || "",
    });
  }, [form, accountData]);

  const handleCancel = () => {
    setAccountView("account");
    navigate("/settings-account");
  };

  const props = {
    showUploadList: false, // Hide default file list
    maxCount: 1,
    // Real upload: get a presigned S3 URL from the backend, PUT the file
    // straight to S3, then keep the resulting public fileUrl (not just the
    // file's local name) so it can actually be saved and rendered later.
    // Without a customRequest, antd's Upload defaults to POSTing the file
    // itself to whatever "action" URL is set - with none configured, that
    // POST target defaulted to the current page URL, which is what caused
    // "Cannot POST /settings-account".
    customRequest: async ({ file, onSuccess, onError }) => {
      if (!clientId) {
        onError(new Error("No client ID"));
        return;
      }
      setUploadingLogo(true);
      try {
        const urlResponse = await uploadUrlRequest({
          endPoint: `/settings/getuploadurl/${clientId}`,
          method: "post",
          data: { file_name: file.name, content_type: file.type },
        });
        const { uploadUrl, fileUrl } = urlResponse?.response || {};
        if (!uploadUrl || !fileUrl) {
          throw new Error("Could not get an upload URL");
        }

        const putResult = await fetch(uploadUrl, {
          method: "PUT",
          headers: { "Content-Type": file.type || "application/octet-stream" },
          body: file,
        });
        if (!putResult.ok) {
          throw new Error(`S3 upload failed with status ${putResult.status}`);
        }

        setUploadedFile({ name: file.name, url: fileUrl });
        message.success("Logo replaced successfully");
        onSuccess("ok");
      } catch (error) {
        console.error("Logo upload error:", error);
        message.error("Logo upload failed");
        onError(error);
      } finally {
        setUploadingLogo(false);
      }
    },
  };

  const onFinish = async (values) => {
    if (!accountId) {
      message.error("Account not loaded yet - please try again.");
      return;
    }

    setSaving(true);

    try {
      const payload = {
        organization_account: values.organizationName,
        // Only overwrite the stored logo if a new file was actually picked -
        // otherwise this wiped out the existing logo on every save that
        // didn't also re-upload one. Explicitly hiding the logo (logoRemoved)
        // clears it even though a new file wasn't uploaded.
        logo: uploadedFile ? uploadedFile.url : logoRemoved ? "" : accountLogoUrl || "",
        time_format: values.timeFormat,
        time_zone: values.timeZone,
        currency: values.currency,
      };

      await request({
        endPoint: `/settings/updateaccount/${clientId}/${accountId}`,
        method: "patch",
        data: payload,
      });

      // Update the header's logo immediately - it reads this same Redux
      // value now instead of only refetching on its own mount.
      dispatch(setOrgLogoUrl(payload.logo || null));
      onSaved?.();
      setIsModalVisible(true);
      setTimeout(() => {
        setIsModalVisible(false);
        setAccountView("account");
        navigate("/settings-account");
      }, 2000);
    } catch (error) {
      console.error("Update account error:", error);
      message.error(
        error?.response?.data?.message ||
          error?.message ||
          "Error occurred while updating account details"
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <StyledAcc>
        <div>
          <div className="breadcrumb-style">
            <p
              onClick={() => setAccountView("account")}
              className="account-style"
            >
              Account
            </p>
            <RightOutlined className="rightoutlined-style" />
            <p className="editing-account-details">Editing Account details</p>
          </div>
          <br />
          <Form
            form={form}
            name="custom-form"
            onFinish={onFinish}
            layout="vertical"
          >
            {/* Row 1: Organization Name / Logo - paired per row (instead of
                two independently-stacked columns) so the Logo field's extra
                height (preview image + button) doesn't push every field
                below it out of alignment with its left-column counterpart. */}
            <div className="field-row">
              <div className="left-right-div">
                <Form.Item
                  name="organizationName"
                  label={
                    <span className="organization-name">Organization Name</span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please enter the organization name",
                    },
                  ]}
                  className="form-item-style"
                >
                  <Input />
                </Form.Item>
              </div>

              <div className="left-right-div">
                <Form.Item
                  name="logo"
                  label={<span className="logo-text">Logo</span>}
                  // Not actually required: Upload never wires a value into
                  // this Form.Item just from existing data (it's not a
                  // controlled field), so a `required` rule here made saving
                  // impossible unless a brand-new file was uploaded on every
                  // single edit, even ones that only touched other fields.
                  className="form-item-style"
                >
                  {!uploadedFile && (
                    <>
                      {accountLogoUrl && !logoRemoved && (
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                          <img
                            src={accountLogoUrl}
                            alt="Current logo"
                            style={{ height: 28, maxWidth: 120, objectFit: "contain" }}
                          />
                          <span style={{ fontSize: 13, color: "#636980" }}>Current logo</span>
                          <CloseOutlined
                            className="remove-logo-icon"
                            onClick={() => setLogoRemoved(true)}
                            aria-label="Hide current logo"
                          />
                        </div>
                      )}
                      <Upload {...props} maxCount={1} className="file_update">
                        <Button className="upload-button" loading={uploadingLogo} disabled={uploadingLogo}>
                          <Uploading className="w-[100%]" />
                          {uploadingLogo
                            ? "Uploading..."
                            : accountLogoUrl && !logoRemoved
                            ? "Replace Logo"
                            : "Upload Profile"}
                        </Button>
                      </Upload>
                    </>
                  )}

                  {uploadedFile && (
                    <div className="">
                      <div className="upload-div">
                        <span className="upload-span">
                          {uploadedFile.name}
                          <CloseOutlined onClick={() => setUploadedFile(null)} />
                        </span>
                      </div>
                    </div>
                  )}
                </Form.Item>
              </div>
            </div>

            {/* Row 2: Time Format / Time Zone */}
            <div className="field-row">
              <div className="left-right-div">
                <Form.Item
                  name="timeFormat"
                  label={<span className="time-format">Time Format</span>}
                  rules={[
                    { required: true, message: "Please select a time format" },
                  ]}
                  className="form-item-style"
                >
                  <Select className="text-left">
                    <Option value="12 hours">12 hours</Option>
                    <Option value="24 hours">24 hours</Option>
                  </Select>
                </Form.Item>
              </div>

              <div className="left-right-div">
                <Form.Item
                  name="timeZone"
                  label={<span className="time-zone">Time Zone</span>}
                  rules={[
                    { required: true, message: "Please select a time zone" },
                  ]}
                  className="form-item-style"
                >
                  <Select className="text-left">
                    <Option value="GMT+00:01">GMT+00:01</Option>
                    <Option value="PST">PST</Option>
                    <Option value="IST">IST</Option>
                  </Select>
                </Form.Item>
              </div>
            </div>

            {/* Row 3: Currency */}
            <div className="field-row">
              <div className="left-right-div">
                <Form.Item
                  name="currency"
                  label={<span className="currency-text">Currency</span>}
                  rules={[
                    { required: true, message: "Please select a currency" },
                  ]}
                  className="form-item-style"
                >
                  <Select className="text-left">
                    <Option value="US Dollar">US Dollar</Option>
                    <Option value="Euro">Euro</Option>
                    <Option value="Indian Rupee">Indian Rupee</Option>
                  </Select>
                </Form.Item>
              </div>

              <div className="left-right-div" />
            </div>
          </Form>

          {/* Bottom Buttons */}
          <div className="button-style">
            <Button className="cancel-button" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              className="save-button"
              type="primary"
              loading={saving}
              onClick={() => form.submit()}
            >
              Save
            </Button>
          </div>
        </div>

        <Modal
          width={180}
          open={isModalVisible}
          footer={null}
          closable={false}
          centered
          style={{ top: 0 }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
            }}
          >
            <Tick style={{ display: "block", width: 22, height: 22 }} />
            <p style={{ margin: 0, fontSize: 16, fontWeight: 400 }}>
              Saved
            </p>
          </div>
        </Modal>
      </StyledAcc>
    </>
  );
};

export default AccountEditAdd;
